import { Collection } from 'src/features/common/types/application/collection';
import { AppDelivery } from 'src/features/common/types/application/delivery';

export const updateDeliveryArrays = (
  deliveries: AppDelivery[],
  collections: Collection[],
  device: AppDelivery | Collection,
  isDelivery: boolean
) => {
  const updatedDeliveries = deliveries.map((delivery) => {
    if (delivery.productId === device.productId && delivery.id === device.id) {
      return {
        ...delivery,
        quantity: isDelivery ? delivery.quantity + device.quantity : delivery.quantity - device.quantity,
      };
    }
    return delivery;
  });

  const updatedCollections = collections.map((collection) => {
    if (collection.productId === device.productId && collection.id === device.id) {
      return {
        ...collection,
        quantity: isDelivery ? collection.quantity - device.quantity : collection.quantity + device.quantity,
      };
    }
    return collection;
  });

  // If the device doesn't exist in the deliveries array and it's a delivery, add it
  if (isDelivery && !deliveries.some((delivery) => delivery.productId === device.productId && delivery.addressId === device.addressId)) {
    updatedDeliveries.push({ ...device, quantity: device.quantity } as AppDelivery);
  }

  // If the device doesn't exist in the collections array and it's not a delivery, add it
  if (!isDelivery && !collections.some((collection) => collection.productId === device.productId && collection.addressId === device.addressId)) {
    updatedCollections.push({ ...device, quantity: device.quantity });
  }

  // eslint-disable-next-line no-console
  console.log(updatedDeliveries, updatedCollections, isDelivery)

  // Return updated arrays deliveries and collections. Exclude items where quantity is 0 or less
  return {
    deliveries: updatedDeliveries.filter((delivery) => delivery.quantity > 0),
    collections: updatedCollections.filter((collection) => collection.quantity > 0),
  };
};